import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<
  RootState,
  KwikspaceStoreState
>(featureKey);

export const getProjectList = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projects
);

export const getProjectListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projectsLoading
);

export const getProjectListError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projectsError
);

export const createProject = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.createProject
);

export const createProjectLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.createProjectLoading
);

export const createProjectError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.createProjectError
);

export const getProject = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.project
);

export const getProjectLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projectLoading
);

export const getProjectError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projectError
);

export const getProductsList = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.productsList
);

export const getProductsListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.productsListLoading
);

export const getProductsListError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.productsListError
);

export const createDesign = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.createDesign
);

export const createDesignLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.createDesignLoading
);

export const createDesignError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.createDesignError
);

export const getDesign = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.design
);

export const getDesignLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.designLoading
);

export const getDesignError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.designError
);

export const getTemplateList = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.templates
);

export const getTemplateListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.templatesLoading
);

export const getTemplateListError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.templatesError
);

export const getTemplate = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.template
);

export const getTemplateLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.templateLoading
);

export const getTemplateError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.templateError
);

export const getProjectProducts = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projectProducts
);

export const getProjectProductsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projectProductsLoading
);

export const getProjectProductsError = createSelector(
  getKwikspaceAppState,
  (state) => state.floorplanner.projectProductsError
);
